import { Line, LineChart, ResponsiveContainer, Tooltip } from 'recharts';

export interface DomainHistoryPoint {
  at: string;
  composite: number;
}

export function HistorySpark({ points }: { points: DomainHistoryPoint[] }) {
  if (points.length < 2) return null;
  const data = points.map((p) => ({
    at: new Date(p.at).getTime(),
    score: p.composite,
  }));
  return (
    <ResponsiveContainer width="100%" height={60}>
      <LineChart data={data} margin={{ top: 4, right: 4, bottom: 4, left: 4 }}>
        <Tooltip
          contentStyle={{
            background: 'oklch(0.20 0.02 250)',
            border: '1px solid oklch(0.30 0.02 250)',
            borderRadius: 6,
            fontSize: 12,
          }}
          labelFormatter={(v) => new Date(Number(v)).toLocaleDateString()}
        />
        <Line
          type="monotone"
          dataKey="score"
          stroke="oklch(0.72 0.15 195)"
          strokeWidth={2}
          dot={{ r: 3, fill: 'oklch(0.72 0.15 195)' }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
